import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-stats-tile',
	templateUrl: './stat-tile.component.html',
	styleUrls: ['./stat-tile.component.scss']
})
export class StatTileComponent {
	@Input() value: number;
	@Input() label: string;
	@Input() color: string;
	@Input() icon: string;
	@Input() description: string;
	constructor() { }
}
